<template>
    <div class="zoom-manager">
        <div class="btn" @click="decreaseZoom" :class="{disabled:isMin}">
            <i class="fa fa-minus"></i>
        </div>
        <div class="label">
            {{ label }}
        </div>
        <div class="btn" @click="increaseZoom" :class="{disabled:isMax}">
            <i class="fa fa-plus"></i>
        </div>
    </div>
</template>

<script>

    import Auth from '@/services/auth.js';

    export default {
        beforeCreate: function () {

        },
        beforeDestroy: function () {

        },
        beforeMount: function () {

        },
        beforeUpdate: function () {

        },
        components: {},
        computed: {
            isMax: function(){
                if(this.zoom == this.max){
                    return true;
                }
                return false;
            },
            isMin: function(){
                if(this.zoom == this.min){
                    return true;
                }
                return false;
            }
        },
        created: function () {

        },
        data() {
            return {
                zoom: this.value
            }
        },
        destroyed: function () {

        },
        methods: {
            increaseZoom: function () {
                if (this.zoom < this.max) {
                    this.zoom += this.step;
                }
            },
            decreaseZoom: function () {
                if (this.zoom > this.min) {
                    this.zoom -= this.step;
                }
            },
            setZoom: function () {
                window.V.$localStorage.set('BPZ_' + Auth.getHash() + '_PATROL_TIMELINE_ZOOM', this.zoom)
                this.$emit('input', this.zoom);
            }
        },
        mounted: function () {

        },
        name: 'ZoomManager',
        props: {
            value: {
                type: Number,
                default: 50
            },
            min: {
                type: Number,
                default: 0
            },
            max: {
                type: Number,
                default: 99
            },
            step: {
                type: Number,
                default: 1
            },
            label: {
                type: String,
                default: ''
            }
        },
        updated: function () {

        },
        watch: {
            value: function (newValue) {
                this.zoom = newValue;

            },
            zoom: function () {
                this.setZoom();
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>